<template>
  <div class="block">
    <div class="blur">
      <CContainer class="hero-container">
        <div class="logo-wrapper">
          <NameComponent class="name" />
          <span class="logo-text">
            Биллинговая система для автоматического учета данных абонентов
          </span>
        </div>

        <div class="abacus-card">
          <span>
            <strong class="brand-highlight">BilliumKG</strong> — биллинговая
            система, которая позволяет легко контролировать учет большого
            количества абонентов, экономя ваше время, обеспечивая безопасность и
            абсолютную точность данных.
          </span>
        </div>

        <el-button type="primary" @click="orderIt" class="call-btn"
          >Оставить заявку</el-button
        >
      </CContainer>
    </div>
  </div>

  <div class="mobile-app">
    <CContainer class="app-container">
      <div class="app-info">
        <span class="app-badge">Доступно для iOS и Android</span>
        <h2 class="app-title">Мобильное приложение "Мой счет"</h2>
        <p class="app-description">
          Забудьте о бумажных квитанциях и необходимости помнить все
          задолженности. С приложением «Мой счет» актуальная информация о
          состоянии ваших лицевых счетов всегда будет у вас под рукой.
        </p>

        <div class="app-features">
          <div class="feature-item">
            <div class="feature-icon">
              <i class="fa-solid fa-bell"></i>
            </div>
            <div class="feature-text">
              <h4>Своевременные уведомления</h4>
              <p>
                Абоненты мгновенно получают Push-уведомления о новых
                начислениях, балансе и сроках оплаты, сводя к нулю просрочки.
              </p>
            </div>
          </div>

          <div class="feature-item">
            <div class="feature-icon">
              <i class="fa-solid fa-clock-rotate-left"></i>
            </div>
            <div class="feature-text">
              <h4>Прозрачная история</h4>
              <p>
                Полная детализация всех начислений и платежей за любой период.
                Информация всегда доступна в один клик.
              </p>
            </div>
          </div>

          <div class="feature-item">
            <div class="feature-icon">
              <i class="fa-solid fa-money-bill-transfer"></i>
            </div>
            <div class="feature-text">
              <h4>Мгновенная оплата 0%</h4>
              <p>
                Удобная оплата счетов через популярные мобильные банкинги
                Кыргызстана (МБанк, MegaPay, О!Деньги) абсолютно без комиссии.
              </p>
            </div>
          </div>
        </div>

        <div class="smart-link-wrapper">
          <a
            href="https://billium.kg/scan"
            class="smart-download-btn"
            target="_blank"
          >
            <div class="btn-icon">
              <i class="fa-brands fa-app-store-ios"></i>
              <i class="fa-brands fa-google-play"></i>
            </div>
            <div class="btn-text">
              <span>Скачать приложение</span>
              <strong>App Store / Google Play</strong>
            </div>
            <i class="fa-solid fa-arrow-right arrow-icon"></i>
          </a>
        </div>
      </div>

      <div class="app-visuals">
        <div class="screenshot-stack">
          <div class="screen s1">
            <img src="/img/screen1.jpeg" alt="Скриншот 1" />
          </div>
          <div class="screen s2">
            <img src="/img/screen2.jpeg" alt="Скриншот 2" />
          </div>
          <div class="screen s3">
            <img src="/img/screen3.jpeg" alt="Скриншот 3" />
          </div>
          <div class="screen s4">
            <img src="/img/screen4.jpeg" alt="Скриншот 4" />
          </div>
        </div>
      </div>
    </CContainer>
  </div>

  <div class="slides">
    <div class="slides-blur">
      <CContainer>
        <h2 class="hero-title text-white">Преимущества</h2>
        <div class="carousel-wrapper">
          <el-carousel :interval="5000" type="card" height="350px">
            <el-carousel-item>
              <div class="carousel-card">
                <div class="carousel-card-content">
                  <h3>Обновление</h3>
                  <p>
                    Постоянные доработки, оптимизация алгоритмов и добавление
                    новых полезных функций.
                  </p>
                </div>
                <div class="carousel-card-img">
                  <img src="/img/report.svg" alt="Report" />
                </div>
              </div>
            </el-carousel-item>

            <el-carousel-item>
              <div class="carousel-card">
                <div class="carousel-card-content">
                  <h3>Удаленная поддержка</h3>
                  <p>
                    В любое рабочее время наши специалисты готовы оперативно
                    подключиться и помочь решить возникшие вопросы.
                  </p>
                </div>
                <div class="carousel-card-img">
                  <img src="/img/Statistics-pana.svg" alt="Support" />
                </div>
              </div>
            </el-carousel-item>

            <el-carousel-item>
              <div class="carousel-card">
                <div class="carousel-card-content">
                  <h3>Облачные технологии</h3>
                  <ul class="cloud-list">
                    <li>
                      <i class="fa-solid fa-circle-check"></i> Вся информация на
                      защищенном сервере
                    </li>
                    <li>
                      <i class="fa-solid fa-circle-check"></i> Доступ с любого
                      устройства 24/7
                    </li>
                    <li>
                      <i class="fa-solid fa-circle-check"></i> Нулевой риск
                      потери баз данных
                    </li>
                  </ul>
                </div>
                <div class="carousel-card-img">
                  <img src="/img/cloud-computing.svg" alt="Cloud" />
                </div>
              </div>
            </el-carousel-item>

            <el-carousel-item>
              <div class="carousel-card">
                <div class="carousel-card-content">
                  <h3>Удобный интерфейс</h3>
                  <p>
                    Простой, легкий и лаконичный дизайн. Найти нужную карту
                    абонента или выгрузить отчет можно всего за пару кликов.
                  </p>
                </div>
                <div class="carousel-card-img">
                  <img src="/img/interface.png" alt="Interface" />
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </CContainer>
    </div>
  </div>

  <div class="billing">
    <CContainer>
      <h2 class="hero-title">Система позволяет</h2>

      <div class="billing-grid">
        <div class="billing-card">
          <div class="billing-card-img">
            <i class="fa-solid fa-file-invoice-dollar"></i>
          </div>
          <div class="billing-card-text">
            Ежемесячное начисление абонентской платы по тарифу
          </div>
        </div>

        <div class="billing-card">
          <div class="billing-card-img">
            <i class="fa-solid fa-wallet"></i>
          </div>
          <div class="billing-card-text">Контроль за оплатой</div>
        </div>

        <div class="billing-card">
          <div class="billing-card-img">
            <i class="fa-solid fa-clock-rotate-left"></i>
          </div>
          <div class="billing-card-text">История абонента</div>
        </div>

        <div class="billing-card">
          <div class="billing-card-img">
            <i class="fa-solid fa-print"></i>
          </div>
          <div class="billing-card-text">Печать извещений</div>
        </div>

        <div class="billing-card">
          <div class="billing-card-img">
            <i class="fa-solid fa-money-bill-transfer"></i>
          </div>
          <div class="billing-card-text">Подключение платежных систем</div>
        </div>

        <div class="billing-card">
          <div class="billing-card-img">
            <i class="fa-solid fa-chart-line"></i>
          </div>
          <div class="billing-card-text">Различные отчеты</div>
        </div>
      </div>
    </CContainer>
  </div>

  <ClientsPartners />

  <div class="about">
    <CContainer>
      <h2 class="hero-title text-white">Наши клиенты</h2>
      <h4 class="sub-title">Частные и государственные организации</h4>

      <div class="clients-grid">
        <div class="client-card">
          <div class="client-icon"><img src="/img/school.png" alt="" /></div>
          <div class="client-text">Частные школы и образовательные курсы</div>
        </div>
        <div class="client-card">
          <div class="client-icon"><img src="/img/sadik.png" alt="" /></div>
          <div class="client-text">Дошкольные образовательные учреждения</div>
        </div>
        <div class="client-card">
          <div class="client-icon"><img src="/img/water.png" alt="" /></div>
          <div class="client-text">
            СООППВ (Потребители питьевой и поливной воды)
          </div>
        </div>
        <div class="client-card">
          <div class="client-icon"><img src="/img/comun.png" alt="" /></div>
          <div class="client-text">Жилищно-коммунальные хозяйства (ЖКХ)</div>
        </div>
        <div class="client-card">
          <div class="client-icon"><img src="/img/musor.png" alt="" /></div>
          <div class="client-text">
            Муниципальные предприятия по вывозу мусора
          </div>
        </div>
        <div class="client-card">
          <div class="client-icon"><img src="/img/report.png" alt="" /></div>
          <div class="client-text">
            Любые компании с регулярной абонентской платой
          </div>
        </div>
      </div>
    </CContainer>
  </div>
</template>

<script>
import NameComponent from '@/components/NameComponent.vue'
import ClientsPartners from '@/components/ClientsPartners.vue'

export default {
  components: { NameComponent, ClientsPartners },
  name: 'Main',

  methods: {
    orderIt() {
      window.open('https://wa.me/996552171111', '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.name {
  font-size: 110px;
}
.hero-title {
  text-align: center;
  font-size: 2.5rem;
  letter-spacing: 1px;
  font-family: 'Vollkorn', serif;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 50px;
  position: relative;

  &::after {
    position: absolute;
    content: '';
    width: 60px;
    height: 4px;
    background: linear-gradient(90deg, #3498db, #9b59b6);
    border-radius: 2px;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.sub-title {
  font-family: 'Vollkorn', serif;
  text-align: center;
  font-size: 1.3rem;
  color: #a2a2c2;
  margin: -20px auto 40px auto;
}

//////////// Блок 1: Главный баннер (Hero) /////////
.block {
  width: 100%;
  min-height: 90vh;
  // Используем качественное абстрактное изображение или оставляем ваше
  background: url('/public/img/otchet3.jpg') no-repeat center center;
  background-size: cover;
  display: flex;

  .blur {
    background: rgba(23, 19, 33, 0.7); // Затемнение в общую тему системы
    backdrop-filter: blur(8px);
    width: 100%;
    display: flex;
    align-items: center;
    padding: 100px 0 60px 0;
  }

  .hero-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 35px;
  }

  .logo-wrapper {
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.1);
    padding: 30px;
    border-radius: 20px;
    backdrop-filter: blur(10px);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
    max-width: 800px;

    .logo-text {
      display: block;
      margin-top: 15px;
      color: #a2a2c2;
      font-size: 1.1rem;
      letter-spacing: 0.5px;
    }
  }

  .abacus-card {
    max-width: 700px;
    font-size: 1.2rem;
    line-height: 1.6;
    color: #e2e2ec;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.08);
    padding: 25px 35px;
    border-radius: 16px;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);

    .brand-highlight {
      color: #3498db;
      text-shadow: 0 0 10px rgba(52, 152, 219, 0.3);
    }
  }

  .call-btn {
    font-size: 1.1rem;
    font-weight: 600;
    height: 55px;
    border-radius: 50px;
    width: 250px;
    background: linear-gradient(90deg, #3498db, #9b59b6) !important;
    border: none !important;
    box-shadow: 0 10px 25px rgba(155, 89, 182, 0.3);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 15px 30px rgba(155, 89, 182, 0.5);
    }
  }
}

////// Блок 2: Возможности (Billing) ///////
.billing {
  padding: 80px 0;
  background-color: #1a1625; // Фирменный темно-фиолетовый фон

  .billing-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 35px;
    margin-top: 20px;
  }

  .billing-card {
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 16px;
    padding: 35px 25px;
    text-align: center;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-5px);
      background: rgba(255, 255, 255, 0.06);
      border-color: rgba(52, 152, 219, 0.4);
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);

      .billing-card-img {
        color: #9b59b6;
        transform: scale(1.05);
      }
    }

    &-img {
      font-size: 4rem;
      color: #3498db;
      margin-bottom: 20px;
      transition: all 0.3s ease;
    }

    &-text {
      font-size: 1.1rem;
      color: #e2e2ec;
      font-weight: 500;
      line-height: 1.4;
    }
  }
}

//////////// Блок 3: Преимущества (Slides) //////////
.slides {
  background: url('/public/img/billing.jpg') no-repeat center center;
  background-size: cover;

  &-blur {
    background: rgba(23, 19, 33, 0.85);
    padding: 80px 0;
  }

  .carousel-wrapper {
    margin-top: 50px;
    :deep(.el-carousel__item) {
      background: rgba(23, 19, 33, 0.45) !important;
      border: 1px solid rgba(255, 255, 255, 0.08) !important;
      border-radius: 20px !important;
      backdrop-filter: blur(16px) !important;
      -webkit-backdrop-filter: blur(16px) !important;
    }
  }

  .carousel-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 30px 50px;
    background: transparent;
    border: none;
    box-shadow: none;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;

    &-content {
      max-width: 55%;
      color: #ffffff;

      h3 {
        font-size: 2rem;
        font-weight: 700;
        margin-bottom: 15px;
        color: #3498db;
      }
      p {
        font-size: 1.1rem;
        line-height: 1.5;
        color: #e2e2ec;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
      }

      .cloud-list {
        list-style: none;
        padding: 0;

        li {
          font-size: 1.05rem;
          margin-bottom: 10px;
          color: #e2e2ec;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          gap: 10px;

          i {
            color: #2ecc71;
          }
        }
      }
    }

    &-img {
      width: 35%;
      display: flex;
      justify-content: center;

      img {
        max-width: 100%;
        max-height: 200px;
        object-fit: contain;
      }
    }
  }
}

//////////// АДАПТИВНОСТЬ ДЛЯ МОБИЛЬНЫХ //////////
@media screen and (max-width: 992px) {
  .sliders {
    padding: 40px 0;
  }

  .blur {
    padding: 40px 0;
  }

  .carousel-wrapper {
    margin-top: 30px;

    :deep(.el-carousel) {
      height: 450px !important;
    }
    :deep(.el-carousel__container) {
      height: 450px !important;
    }

    :deep(.el-carousel__item) {
      width: 100% !important;
      transform: none !important;
      left: 0 !important;
      opacity: 0;
      visibility: hidden;

      &.is-active {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  .carousel-card {
    flex-direction: column-reverse;
    justify-content: center;
    gap: 15px;
    padding: 20px !important;
    text-align: center;

    &-content {
      max-width: 100%;

      h3 {
        font-size: 1.5rem;
        margin-bottom: 8px;
      }
      p {
        font-size: 0.95rem;
        line-height: 1.4;
      }

      .cloud-list {
        li {
          font-size: 0.9rem;
          justify-content: center;
          gap: 6px;
        }
      }
    }

    &-img {
      width: 100%;

      img {
        max-height: 100px;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .carousel-wrapper {
    :deep(.el-carousel),
    :deep(.el-carousel__container) {
    }
  }
  .carousel-card {
    &-img {
      display: none;
    }
  }
}

////// Блок 4: Клиенты (About) ///////
.about {
  background-color: #1a1625;
  padding: 80px 0;

  .clients-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 25px;
    margin-top: 20px;
  }

  .client-card {
    display: flex;
    align-items: center;
    gap: 20px;
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.05);
    padding: 20px;
    border-radius: 12px;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.05);
      border-color: rgba(155, 89, 182, 0.3);
      transform: translateX(5px);
    }

    .client-icon {
      width: 70px;
      height: 70px;
      flex-shrink: 0;
      background: rgba(255, 255, 255, 0.05);
      border-radius: 10px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }

    .client-text {
      font-size: 1.05rem;
      color: #e2e2ec;
      font-weight: 500;
      line-height: 1.4;
    }
  }
}

//////////// Глубокая адаптивность (Media queries) //////////
@media screen and (max-width: 992px) {
  .hero-title {
    font-size: 2rem;
  }
  .sub-title {
    font-size: 1.1rem;
  }

  .block .logo-wrapper {
    padding: 20px;
    .logo-text {
      font-size: 0.95rem;
    }
  }

  .carousel-card {
    flex-direction: column-reverse;
    justify-content: center;
    gap: 20px;
    padding: 20px !important;
    text-align: center;

    &-content {
      max-width: 100% !important;
      h3 {
        font-size: 1.5rem;
      }
      p {
        font-size: 0.95rem;
      }
      .cloud-list li {
        font-size: 0.9rem;
        justify-content: center;
      }
    }
    &-img {
      width: 100% !important;
      img {
        max-height: 110px;
      }
    }
  }
}

@media screen and (max-width: 576px) {
  .name {
    font-size: 75px;
  }

  .hero-title {
    font-size: 1.7rem;
  }

  .block {
    .abacus-card {
      font-size: 1rem;
      padding: 15px 20px;
    }
    .call-btn {
      width: 100%;
      max-width: 250px;
    }
  }

  .billing-card {
    padding: 20px 15px;
    &-img {
      font-size: 3rem;
    }
    &-text {
      font-size: 1rem;
    }
  }

  :deep(.el-carousel__indicators--card) {
    display: none;
  }
}
//////////// Блок: Мобильное приложение (Каскад скриншотов) /////////
.mobile-app {
  background-color: #1a1625;
  padding: 120px 0;
  overflow: hidden;

  .app-container {
    display: flex;
    align-items: center;
    gap: 80px;
  }

  .app-info {
    flex: 1;
    z-index: 10;
  }

  /* Исправление цветов текстовых фич */
  .app-features {
    display: flex;
    flex-direction: column;
    gap: 25px;
    margin-top: 30px;
  }

  .feature-item {
    display: flex;
    align-items: flex-start;
    gap: 20px;
  }

  .feature-icon {
    width: 50px;
    height: 50px;
    background: rgba(52, 152, 219, 0.1);
    border: 1px solid rgba(52, 152, 219, 0.25);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #3498db;
    font-size: 1.3rem;
    flex-shrink: 0;
  }

  .feature-text {
    text-align: left; /* Гарантирует выравнивание влево */

    h4 {
      margin: 0 0 6px 0;
      font-size: 1.2rem;
      font-weight: 600;
      color: #ffffff !important; /* Яркий белый цвет для заголовка фичи */
    }

    p {
      margin: 0;
      font-size: 1rem;
      line-height: 1.5;
      color: #a2a2c2 !important; /* Контрастный светлый текст для описания */
    }
  }

  /* Основные тексты блока */
  .app-title {
    font-family: 'Vollkorn', serif;
    font-size: 3rem;
    font-weight: 700;
    color: #ffffff;
    margin: 20px 0;
    line-height: 1.1;
  }

  .app-badge {
    background: rgba(155, 89, 182, 0.15);
    color: #9b59b6;
    padding: 6px 16px;
    border-radius: 50px;
    font-size: 0.9rem;
    font-weight: 600;
    letter-spacing: 0.5px;
    display: inline-block;
    border: 1px solid rgba(155, 89, 182, 0.2);
  }

  .app-description {
    font-size: 1.2rem;
    color: #a2a2c2;
    margin-bottom: 40px;
    max-width: 500px;
    line-height: 1.6;
  }

  /* Умная кнопка */
  .smart-link-wrapper {
    margin-top: 50px;
  }

  .smart-download-btn {
    display: inline-flex;
    align-items: center;
    background: linear-gradient(135deg, #3498db 0%, #9b59b6 100%);
    padding: 15px 30px;
    border-radius: 20px;
    color: white;
    text-decoration: none;
    gap: 20px;
    box-shadow: 0 15px 35px rgba(155, 89, 182, 0.3);
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);

    .btn-icon {
      font-size: 2rem;
      display: flex;
      gap: 8px;
    }

    .btn-text {
      display: flex;
      flex-direction: column;
      span {
        font-size: 0.9rem;
        opacity: 0.9;
      }
      strong {
        font-size: 1.2rem;
        font-weight: 700;
      }
    }

    .arrow-icon {
      font-size: 1.2rem;
      transition: transform 0.3s ease;
    }

    &:hover {
      transform: translateY(-5px) scale(1.02);
      box-shadow: 0 20px 40px rgba(155, 89, 182, 0.5);
      .arrow-icon {
        transform: translateX(8px);
      }
    }
  }

  /* Визуальный стек скриншотов */
  .app-visuals {
    flex: 1.2;
    position: relative;
    height: 600px;
  }

  .screenshot-stack {
    position: relative;
    width: 100%;
    height: 100%;

    .screen {
      position: absolute;
      width: 260px;
      height: 520px;
      border-radius: 30px;
      overflow: hidden;
      box-shadow: 0 30px 60px rgba(0, 0, 0, 0.5);
      border: 6px solid #2d263f;
      background: #171321;
      transition: all 0.5s ease;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      &.s1 {
        z-index: 4;
        left: 0;
        top: 0;
      }
      &.s2 {
        z-index: 3;
        left: 80px;
        top: 40px;
        opacity: 0.8;
      }
      &.s3 {
        z-index: 2;
        left: 160px;
        top: 80px;
        opacity: 0.6;
      }
      &.s4 {
        z-index: 1;
        left: 240px;
        top: 120px;
        opacity: 0.4;
      }

      &:hover {
        z-index: 10;
        opacity: 1;
        transform: translateY(-20px) scale(1.05);
        border-color: #3498db;
      }
    }
  }
}

//////////// АДАПТИВНОСТЬ //////////
@media screen and (max-width: 1200px) {
  .mobile-app .screenshot-stack .screen {
    width: 200px;
    height: 400px;
  }
}

@media screen and (max-width: 992px) {
  .mobile-app {
    padding: 80px 0;
    .app-container {
      flex-direction: column;
      text-align: center;
      gap: 60px;
    }
    .app-description {
      margin: 0 auto 40px auto;
    }
    .feature-text {
      text-align: center; /* Центрируем тексты на планшетах/мобилках */
    }
    .feature-item {
      flex-direction: column;
      align-items: center;
      gap: 10px;
    }
    .app-visuals {
      height: 450px;
      width: 100%;
    }
    .screenshot-stack {
      display: flex;
      justify-content: center;
      .screen {
        position: relative;
        left: 0 !important;
        top: 0 !important;
        margin: 0 -30px;
        transform: scale(0.9);
        opacity: 1 !important;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .screenshot-stack .screen {
    &:nth-child(n + 3) {
      display: none;
    }
    margin: 0 -10px;
  }
  .smart-download-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
